import { render, staticRenderFns } from "./Subsidy.vue?vue&type=template&id=32ebb026&scoped=true&"
import script from "./Subsidy.vue?vue&type=script&lang=js&"
export * from "./Subsidy.vue?vue&type=script&lang=js&"
import style0 from "./Subsidy.vue?vue&type=style&index=0&id=32ebb026&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebb026",
  null
  
)

export default component.exports